import * as React from "react"

export const VimeoLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    className="fill-fg-1"
    {...props}>
    <g clipPath="url(#a)">
      <path d="M23.977 6.417c-.105 2.338-1.74 5.543-4.894 9.609-3.268 4.247-6.026 6.37-8.29 6.37-1.41 0-2.578-1.294-3.553-3.881L5.322 11.4c-.72-2.584-1.488-3.878-2.312-3.878-.18 0-.806.378-1.881 1.132L0 7.198A315.119 315.119 0 0 0 3.501 4.07C5.08 2.702 6.266 1.985 7.055 1.91c1.867-.18 3.016 1.1 3.447 3.839.465 2.953.789 4.789.97 5.507.54 2.45 1.132 3.674 1.777 3.674.502 0 1.256-.796 2.265-2.385 1.004-1.59 1.54-2.797 1.612-3.628.144-1.371-.395-2.061-1.614-2.061-.574 0-1.167.12-1.777.39C14.92 3.38 17.169 1.49 20.497 1.61c2.473.06 3.628 1.664 3.493 4.797l-.013.01Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
